import SuperRepository from '../superRepository'

export default new (class partnerSpendCustomPercentRepository extends SuperRepository {
    baseUri() {
        return 'partner_spend_custom_percent'
    }
})()
